import { render, staticRenderFns } from "./DeleteBusinessTypeModal.vue?vue&type=template&id=6033e865&"
import script from "./DeleteBusinessTypeModal.vue?vue&type=script&lang=js&"
export * from "./DeleteBusinessTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports